module.exports = "<object id=\"map-svg\" class=\"stadium-img\"  type=\"image/svg+xml\" [data]=\"url\">\n</object>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/group/components/choose-seats/seat-map/seat-map.component.html
// module id = ./src/app/modules/group/components/choose-seats/seat-map/seat-map.component.html
// module chunks = main